var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      attrs: {
        id: "dropdown_template_settings",
        variant: "outline-success",
        "no-caret": "",
      },
      scopedSlots: _vm._u([
        {
          key: "button-content",
          fn: function () {
            return [
              _c(
                "a",
                {
                  staticClass: "header-icon",
                  attrs: {
                    href: "#",
                    "data-toggle": "modal",
                    "data-target": "js-modal-settings",
                  },
                },
                [_c("i", { staticClass: "fal fa-cog" })]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "b-dropdown-form",
        { staticClass: "notif_user dropdown-xl settings-panel" },
        [
          _c(
            "div",
            {
              staticClass:
                "dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center rounded-top",
            },
            [
              _c(
                "h4",
                {
                  staticClass: "m-0 text-center color-white",
                  attrs: { "data-v-7149ec54": "" },
                },
                [
                  _vm._v("Налаштування Шаблону\n                "),
                  _c(
                    "small",
                    {
                      staticClass: "mb-0 opacity-80",
                      attrs: { "data-v-7149ec54": "" },
                    },
                    [
                      _vm._v(
                        "\n                    Тут ви можете обрати свій варіант кольору та схеми\n                "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "list mt-1" }, [
            _c("span", { staticClass: "onoffswitch-title" }, [
              _vm._v("Загальний Розмір"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "btn-group btn-group-sm btn-group-toggle my-2",
                attrs: { "data-toggle": "buttons" },
              },
              _vm._l(_vm.template_sizes, function (size) {
                return _c(
                  "label",
                  {
                    staticClass:
                      "btn btn-default btn-sm waves-effect waves-themed",
                    attrs: {
                      "data-action": "toggle-swap",
                      "data-class": size.type,
                      "data-target": "html",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.set_active_size(size)
                      },
                    },
                  },
                  [
                    _c("input", {
                      attrs: { type: "radio", name: "changeFrontSize" },
                    }),
                    _vm._v(" " + _vm._s(size.name) + "\n                "),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 d-table w-100 pl-5 pr-3" }, [
            _c("div", { staticClass: "d-table-cell align-middle" }, [
              _c("h5", { staticClass: "p-0 pr-2 d-flex" }, [
                _vm._v("Схеми шаблону"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pl-5 pr-3 py-3" }, [
            _c(
              "div",
              { staticClass: "row no-gutters" },
              _vm._l(_vm.template_skins, function (template) {
                return _c("div", { staticClass: "col-4 pr-2 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex bg-white border rounded overflow-hidden text-success js-waves-on waves-effect waves-themed",
                      class: template.inside_class.add_class,
                      staticStyle: { height: "80px" },
                      attrs: {
                        id: template.id,
                        "data-placement": "top",
                        "data-replaceclass": "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.set_skin(template)
                        },
                      },
                    },
                    [
                      _c("div", {
                        staticClass: "px-2 pt-0 border-right",
                        class: template.inside_class.left_class,
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex flex-column flex-1" }, [
                        _c("div", {
                          staticClass: "border-bottom py-1",
                          class: template.inside_class.level1,
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "flex-1 pt-3 pb-3 px-2",
                          class: template.inside_class.level2,
                        }),
                      ]),
                    ]
                  ),
                  _vm._v(
                    "\n                    " +
                      _vm._s(template.name) +
                      "\n                "
                  ),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 d-table w-100 pl-5 pr-3" }, [
            _c("div", { staticClass: "d-table-cell align-middle" }, [
              _c("h5", { staticClass: "p-0 pr-2 d-flex" }, [
                _vm._v("Кольорова гамма"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pl-3 pr-3 py-3" }, [
            _c("div", { staticClass: "expanded theme-colors" }, [
              _c(
                "ul",
                { staticClass: "m-0" },
                _vm._l(_vm.template_colors, function (color) {
                  return _c(
                    "li",
                    {
                      class: { active: color.is_active },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.set_color(color)
                        },
                      },
                    },
                    [
                      _c("a", {
                        attrs: {
                          href: "#",
                          "data-action": "",
                          id: color.div_id,
                          title: "",
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pl-3 pr-3 py-3" }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-lg btn-outline-success waves-effect waves-themed",
                attrs: { type: "button" },
                on: { click: _vm.save_settings },
              },
              [
                _c("span", { staticClass: "fal fal fa-check mr-1" }),
                _vm._v("\n                Зберегти\n            "),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }